import { render, staticRenderFns } from "./addProductPhoto.vue?vue&type=template&id=62cc1021&scoped=true"
import script from "./addProductPhoto.vue?vue&type=script&lang=js"
export * from "./addProductPhoto.vue?vue&type=script&lang=js"
import style0 from "./addProductPhoto.vue?vue&type=style&index=0&id=62cc1021&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62cc1021",
  null
  
)

export default component.exports